import { object, string } from "yup";

export const PageTypeSchema = object({
  page_type: string<
    "reederei" | "hafen" | "schiff" | "zielgebiet" | "reise" | "/"
  >().required(),
});
